import React, { useEffect } from 'react'
import { yupResolver } from '@hookform/resolvers'
import { useForm } from 'react-hook-form'

import { ModalBase, Text, Column, Row, Button, Select, Input } from '../../../index'

import { modalAproveResolver } from '../../../../../schemas'

const defaultValue = { name: '' }

const ModalAproveDoc = ({ open, handleClose, handleAproveDoc, documentType }) => {
  const {
    control,
    errors,
    handleSubmit,
    reset,
    formState: { isSubmitting }
  } = useForm({
    resolver: yupResolver(modalAproveResolver),
    defaultValues: defaultValue
  })

  const onSubmit = async data => {
    try {
      handleAproveDoc(open, data)
    } catch {
    } finally {
      handleClose()
    }
  }

  useEffect(() => {
    reset({ name: open.filename && open.filename.split('.').shift() })
  }, [open])

  return (
    <ModalBase open={!!open ? true : false} onClose={handleClose} height='100%' width='100%' title='Documento'>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Column justifyContent='space-around' style={{ gap: '20px' }}>
          <Text variant='h4'>Você tem certeza que deseja aceitar este documento?</Text>
          <Select
            rigth='true'
            name='document_type'
            label='Tipo de documento'
            control={control}
            error={errors.document_type}
            options={documentType.map(item => {
              return { value: item.id, label: item.name }
            })}
            mb='10px'
          />
          <Input name='name' label='Nome' control={control} error={errors.name} />
          <Row>
            <Button height={40} width={227} onClick={handleClose} mr={3} variant='outlined'>
              Cancelar
            </Button>
            <Button height={40} width={227} type='submit' loader={isSubmitting}>
              Aceitar
            </Button>
          </Row>
        </Column>
      </form>
    </ModalBase>
  )
}

export default ModalAproveDoc
